(function(window, document) {

    var DEFAULT_MODE = 'light';

    function getCurrentMode() {
        var savedMode = localStorage.getItem('theme-mode');
        if (savedMode)
            return savedMode;
        
        var preferredMode;
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
            preferredMode = 'dark';
        else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches)
            preferredMode = 'light';

        return preferredMode || DEFAULT_MODE;
    }

    function toggleDarkMode() {
        var mode = getCurrentMode() === 'light' ? 'dark' : 'light';
        updateStyle(mode);
        localStorage.setItem('theme-mode', mode);
    }
    window.toggleDarkMode = toggleDarkMode;

    function updateStyle(mode) {
        if (mode == 'dark')
            document.querySelector('body').classList.add('dark');
        else 
            document.querySelector('body').classList.remove('dark');
    }

    updateStyle(getCurrentMode());
})(window, document);
